import React, { useContext, useEffect } from 'react'
import BreadCrumb from '../components/BreadCrumb.jsx'
import { v4 as uuidv4 } from 'uuid'
import { StateContext } from '../services/StateService.jsx'
import { syncFuzeBreadcrumbs } from '../services/UtilityService.jsx'
import '../css/BreadCrumbs.scss'

/**
 * This is the list of Breadcrumbs for SNAPS 2
 * Patches the FUZE breadcrumb DOM element with missing items from breadcrumbsList.
 * breadcrumbsList[0] is always the env-specific root (e.g. "Search Results") and is ignored.
 * FUZE items before breadcrumbsList[1] are marked as data-fuze-root (recalculated on each render).
 * SNAPS2 items are marked as data-snaps2-injected and re-injected on every render.
 * Only runs in FUZE environments (fuzeRequest truthy).
 * @param {array} breadcrumbsList The array of breadcrumb details from the server
 */
const BreadCrumbList = ({ breadcrumbsList }) => {
    const { fuzeRequest } = useContext(StateContext)

    useEffect(() => {
        if (!fuzeRequest || !breadcrumbsList) return
        const container = document.querySelector('.MMM--breadcrumbs-list')
        if (!container) return
        syncFuzeBreadcrumbs(container, breadcrumbsList)
    }, [breadcrumbsList, fuzeRequest])

    if (fuzeRequest) return null

    // This component only renders in development environments e.g. Localhost & OpenShift
    return (
        <div className="sps2-breadcrumbs">
            <ol className="sps2-breadcrumbs_list">
                {breadcrumbsList?.map((crumb) => (
                    <BreadCrumb
                        key={uuidv4()}
                        value={crumb.value}
                        removeUrl={crumb.removeUrl}
                    />
                ))}
            </ol>
        </div>
    )
}

export default BreadCrumbList